export const staticURLs = {
  imageBasePath: 'https://bl-public-storage.s3.amazonaws.com/',

}
